import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  Paper,
  TableContainer,
  TableSortLabel,
} from '@material-ui/core';
import moment from 'moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ExcelExport from './ExportExcel';
import { fetchSummaryByDayReport } from '../../../../../redux/timesheets/timesheetsActions';
import { convertFloat, groupBy } from '../../../../../redux/utils/customMethods';
import { useStyles, StyledTableCell, StyledTableRow } from '../../../adminStyles';
import { DB_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../../../redux/constants';

const hoursType = {
  regular: 'Regular Hours',
  vacation: 'Vacation Hours',
  holiday: 'Holiday Hours',
  sick: 'Sick Hours',
};
const maxDays = 31;
const SummaryByDay = () => {
  document.title = 'Sciata Summary By Day';

  const {
    approveBtn,
    tableRoot,
    tableContainer,
    gridElLeft,
    gridElRight,
    btnMobile,
    inputMobile,
    sortLabel,
  } = useStyles();

  const dispatch = useDispatch();
  const reportData = useSelector(state => state.timesheets.byDay || []);
  const [nameOrderAsc, setNameOrderAsc] = useState(true);
  const [nameAsc, setNameAsc] = useState('desc');
  const [dateOrderAsc, setDateOrderAsc] = useState(true);
  const [dateAsc, setDateAsc] = useState('desc');
  const [hoursOrderAsc, setHoursOrderAsc] = useState(true);
  const [hoursAsc, setHoursAsc] = useState('desc');
  const [rows, setRows] = useState([]);
  const [fromDate, setFromDate] = useState(moment().format(DB_DATE_FORMAT));
  const [toDate, setToDate] = useState(moment().format(DB_DATE_FORMAT));
  const [toMaxDate, setToMaxDate] = useState(
    moment().startOf('month').add(maxDays, 'days')
  );
  const [hrsType, setHrsType] = useState(Object.keys(hoursType)[0]);
  const [selectedHrsType, setSelectedHrsType] = useState('regular');
  const [headerHours, setheaderHours] = useState('Regular Hours');
  const [openToDate, setOpenToDate] = useState(false);
  const [orderBy, setOrderBy] = useState('');

  useEffect(() => {
    handleGo();
  }, []);

  useEffect(() => {
    setRows(groupBy(reportData, 'userName'));
    console.log("",JSON.stringify(reportData))
  }, [reportData]);

  const handleGo = () => {
    setheaderHours(hoursType[selectedHrsType]);
    dispatch(
      fetchSummaryByDayReport({
        fromDate: moment(fromDate).format('MM-DD-YYYY'),
        toDate: moment(toDate).format('MM-DD-YYYY'),
        type: selectedHrsType || 'regular',
      })
    );
  };

  const totals = (items, key) => {
    return items.map(item => convertFloat(item[key])).reduce((sum, i) => sum + i, 0);
  };

  const handleDateSortClick = () => {
    setDateOrderAsc(!dateOrderAsc);
    dateOrderAsc ? setDateAsc('asc') : setDateAsc('desc');
    setOrderBy('date');
  };

  const orderByDate = data => {
    return data.sort(function (a, b) {
      if (orderBy === 'date' && dateAsc === 'asc') {
        return (
          moment(a.date, 'YYYY-MM-DD HH:mm:ss.SSS') -
          moment(b.date, 'YYYY-MM-DD HH:mm:ss.SSS')
        );
      }
      return (
        moment(b.date, 'YYYY-MM-DD HH:mm:ss.SSS') -
        moment(a.date, 'YYYY-MM-DD HH:mm:ss.SSS')
      );
    });
  };

  const handleHoursSortClick = () => {
    setHoursOrderAsc(!hoursOrderAsc);
    hoursOrderAsc ? setHoursAsc('asc') : setHoursAsc('desc');
    setOrderBy('hours');
  };

  const orderByHours = data => {
    return data.sort(function (a, b) {
      if (orderBy === 'hours' && hoursAsc === 'asc') {
        return a.hours - b.hours;
      }
      return b.hours - a.hours;
    });
  };

  const handleNameSortClick = () => {
    setNameOrderAsc(!nameOrderAsc);
    nameOrderAsc ? setNameAsc('asc') : setNameAsc('desc');
    setOrderBy('name');
  };

  const orderByName = data => {
    //console.log('DATA', data)
    return nameAsc === 'asc'
      ? Object.keys(data).sort(() => 1)
      : Object.keys(data).sort(() => -1);
    // Object.keys(data).sort((a, b) => {
    //   let nameA = a.name.toUpperCase();
    //   let nameB = b.name.toUpperCase();

    //   if (nameAsc === 'asc') {
    //     if (nameA < nameB) return -1;
    //     if (nameA > nameB) return 1;
    //     return 0;
    //   }
    //   if (!nameAsc === 'asc') {
    //     if (nameB < nameA) return -1;
    //     if (nameB > nameA) return 1;
    //     return 0;
    //   }
    // });
  };

  return (
    <>
      <h1>Summary By Day</h1>
      <Grid container justify='center' alignItems='center'>
        <Grid item xs={12} md={3} className={gridElLeft}>
          <FormControl variant='outlined' className={inputMobile}>
            <Select
              value={selectedHrsType || hrsType}
              onChange={e => {
                setSelectedHrsType(e.target.value);
              }}
            >
              {Object.keys(hoursType).map((item, k) => {
                return (
                  <MenuItem key={k} value={item}>
                    {hoursType[item]}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} container spacing={1}>
          <Grid item xs={12} md={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-From-picker-inline'
                label='From Date'
                value={moment(fromDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(true);
                  setToMaxDate(moment(date).add(maxDays, 'days'));
                  setFromDate(date);
                  if (moment(toDate, DB_DATE_FORMAT) > toMaxDate) {
                    setToDate(moment(date).add(maxDays, 'days').format(DB_DATE_FORMAT));
                  }
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} md={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                open={openToDate}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-To-picker-inline'
                label='To Date'
                value={moment(toDate, DB_DATE_FORMAT)}
                minDate={fromDate}
                maxDate={toMaxDate}
                autoOk={true}
                onChange={date => {
                  setToDate(moment(date).format(DB_DATE_FORMAT));
                  setOpenToDate(false);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid item xs={12} md={3} className={gridElRight}>
          <Button className={btnMobile} onClick={handleGo} variant='contained'>
            Go
          </Button>
          <ExcelExport
            approveBtn={approveBtn}
            exportDataSet={reportData}
            fromDate={fromDate}
            toDate={toDate}
            hrsType={hoursType[selectedHrsType]}
          />
        </Grid>
      </Grid>
      <Paper className={tableRoot}>
        <TableContainer className={tableContainer}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={orderBy === 'name'}
                    direction={nameAsc}
                    onClick={handleNameSortClick}
                    className={sortLabel}
                  >
                    Name
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={orderBy === 'date'}
                    direction={dateAsc}
                    onClick={handleDateSortClick}
                    className={sortLabel}
                  >
                    Date
                  </TableSortLabel>
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <TableSortLabel
                    active={orderBy === hoursType[selectedHrsType]}
                    direction={hoursAsc}
                    onClick={handleHoursSortClick}
                    className={sortLabel}
                  >
                    {headerHours}
                  </TableSortLabel>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderByName(rows).map(row => {
                const eid =
                  (rows[row][0].empId || null) == null ? '' : ` [${rows[row][0].empId}]`;
                return (
                  <>
                    <TableRow>
                      <TableCell
                        align='center'
                        rowspan={(rows[row] || []).length > 0 ? rows[row].length + 2 : 2}
                        style={{ border: '1px solid black', backgroundColor: '#C6C6C6' }}
                      >
                        {row + eid}
                      </TableCell>
                    </TableRow>
                    {orderBy === 'date'
                      ? orderByDate(rows[row] || []).map(r => {
                          return (
                            <TableRow>
                              <TableCell align='center'>
                                {moment(r.date, 'YYYY-MM-DD HH:mm:ss.SSS').format(
                                  DISPLAY_DATE_FORMAT
                                )}
                              </TableCell>
                              <TableCell align='center'>
                                {convertFloat(r.hours).toFixed(2)}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      : orderByHours(rows[row] || []).map(r => {
                          return (
                            <TableRow>
                              <TableCell align='center'>
                                {moment(r.date, 'YYYY-MM-DD HH:mm:ss.SSS').format(
                                  DISPLAY_DATE_FORMAT
                                )}
                              </TableCell>
                              <TableCell align='center'>
                                {convertFloat(r.hours).toFixed(2)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    <TableRow>
                      <TableCell align='center'>
                        <b>Total:</b>
                      </TableCell>
                      <TableCell align='center'>
                        <b>{totals(rows[row], 'hours').toFixed(2)}</b>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};
export default SummaryByDay;
